export enum SyncTimePeriodMode {
  CurrentFiscalYear = 'currentFiscalYear',
  FromSelectedDate = 'fromSelectedDate',
}
